import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../../../../Icon';
import PrivacyIcon from '../../../../../PrivacyIcon';
import { formatDate } from '../../../../utils';
import styles from '../index.styl';

const FamilyHistoryCard = ({ entity }) => {
  const { condition, startDate, isPrivate } = entity;
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.leftSideWrapper}>
          <Icon
            size={28}
            name="icon-family-history-black"
            className={styles.iconType}
          />
          <div className={styles.contentWrapper}>
            <div className={styles.title}>
              <div
                className={cn(styles.titleWrapper, {
                  [styles.noTitle]: !condition,
                })}
              >
                {condition}
              </div>
              <PrivacyIcon show={isPrivate} className={styles.privacyIcon} />
            </div>
            <div className={styles.description}>
              {startDate ? formatDate(startDate, 'MMM D, Y') : ''}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FamilyHistoryCard.propTypes = {
  entity: PropTypes.object,
};

export default FamilyHistoryCard;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/FamilyHistoryCard/index.jsx